import { __awaiter, __decorate, __extends, __generator } from "tslib";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
var DetailExpander = /** @class */ (function (_super) {
    __extends(DetailExpander, _super);
    function DetailExpander() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.detailsExpanded = false;
        _this.showMore = true;
        _this.windowWidth = window.innerWidth;
        return _this;
    }
    DetailExpander.prototype.getWindowWidth = function () {
        return this.windowWidth = window.innerWidth;
    };
    DetailExpander.prototype.toggle = function () {
        if (this.detailsExpanded) {
            var detailContainer = this.$refs.details;
            var headerOffset = 0;
            if (document.getElementsByTagName('header')) {
                headerOffset = document.getElementsByTagName('header')[0].offsetHeight;
            }
            var elementPosition = detailContainer.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.scrollY - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
        this.detailsExpanded = !this.detailsExpanded;
    };
    Object.defineProperty(DetailExpander.prototype, "lines", {
        get: function () {
            if (this.windowWidth > 1023) {
                return this.linesdesktop;
            }
            else if (this.windowWidth > 767 && this.windowWidth <= 1023) {
                return this.linestablet;
            }
            else {
                return this.linesmobile;
            }
        },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(DetailExpander.prototype, "height", {
        get: function () {
            if (this.windowWidth > 1023) {
                return this.heightdesktop;
            }
            else if (this.windowWidth > 767 && this.windowWidth <= 1023) {
                return this.heighttablet;
            }
            else {
                return this.heightmobile;
            }
        },
        enumerable: false,
        configurable: true
    });
    ;
    DetailExpander.prototype.updated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.asyncShowMore()];
                    case 1:
                        _a.showMore = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DetailExpander.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.asyncShowMore()];
                    case 1:
                        _a.showMore = _b.sent();
                        this.getWindowWidth();
                        window.addEventListener('resize', function () {
                            _this.getWindowWidth();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DetailExpander.prototype.asyncShowMore = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (res) {
                            _this.$nextTick(function () {
                                var desc = _this.$refs.details;
                                var showMore = (desc === null || desc === void 0 ? void 0 : desc.offsetHeight) !== (desc === null || desc === void 0 ? void 0 : desc.scrollHeight);
                                if (showMore) {
                                    showMore = (desc === null || desc === void 0 ? void 0 : desc.offsetHeight) + 1 !== (desc === null || desc === void 0 ? void 0 : desc.scrollHeight);
                                }
                                res(showMore);
                            });
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    __decorate([
        Prop({ default: 3 })
    ], DetailExpander.prototype, "linesdesktop", void 0);
    __decorate([
        Prop({ default: 3 })
    ], DetailExpander.prototype, "linestablet", void 0);
    __decorate([
        Prop({ default: 3 })
    ], DetailExpander.prototype, "linesmobile", void 0);
    __decorate([
        Prop({ default: 0 })
    ], DetailExpander.prototype, "heightdesktop", void 0);
    __decorate([
        Prop({ default: 0 })
    ], DetailExpander.prototype, "heighttablet", void 0);
    __decorate([
        Prop({ default: 0 })
    ], DetailExpander.prototype, "heightmobile", void 0);
    __decorate([
        Prop({ default: '' })
    ], DetailExpander.prototype, "more", void 0);
    __decorate([
        Prop({ default: '' })
    ], DetailExpander.prototype, "less", void 0);
    DetailExpander = __decorate([
        Component
    ], DetailExpander);
    return DetailExpander;
}(Vue));
export default DetailExpander;
